import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { initializeDateConfiguration } from './app/core/config/date.config';

// Inicializar configuración de fechas antes de arrancar la aplicación
initializeDateConfiguration();

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
